// extracted by mini-css-extract-plugin
module.exports = {"cardInfo":"_3GcfM-WapU_XcNcsGaAqn8","teamName":"GT3jUJKZ4eqcEH1ef45pI","date":"_3D6uugzioj1PivCmzdFhwm"};